import { Head } from "@inertiajs/react";
import { ConnectAccountManagement, ConnectNotificationBanner } from "@stripe/react-connect-js";
import { t } from "@travily/i18n";
import {
  accountPayoutsConnectSessionPath,
  accountPayoutsDocumentsPath,
  accountPayoutsManagePath,
  accountPayoutsPath,
  accountPayoutsSalesPath,
} from "@travily/routes";
import { useStripeConnectSessionRefresher } from "@/hooks/use-stripe-connect-session-refresher";
import { PageFrame } from "@/layouts/page-frame";
import type { PayoutsTab } from "@/pages/account/payouts/components/PayoutsFrame";
import { AccountPayoutsManageView } from "./manage.view";

interface AccountPayoutsManageProps {
  client_secret: string;
  publishable_key: string;
}

const AccountPayoutsManagePage = ({ client_secret, publishable_key }: AccountPayoutsManageProps) => {
  const fetchRefreshedClientSecret = useStripeConnectSessionRefresher(accountPayoutsConnectSessionPath());
  const tabs = useTabs();

  return (
    <PageFrame mode="creator">
      <Head title={t("web.accounts.payouts.show.meta_title")} />
      <AccountPayoutsManageView
        fetchRefreshedClientSecret={fetchRefreshedClientSecret}
        initialClientSecret={client_secret}
        publishableKey={publishable_key}
        tabs={tabs}
      >
        <ConnectNotificationBanner />
        <ConnectAccountManagement />
      </AccountPayoutsManageView>
    </PageFrame>
  );
};

function useTabs(): PayoutsTab[] {
  return [
    { key: "overview", label: t("components.frames.payouts.tabs.overview"), href: accountPayoutsPath() },
    { key: "sales", label: t("components.frames.payouts.tabs.sales"), href: accountPayoutsSalesPath() },
    { key: "manage", label: t("components.frames.payouts.tabs.manage"), href: accountPayoutsManagePath() },
    { key: "documents", label: t("components.frames.payouts.tabs.documents"), href: accountPayoutsDocumentsPath() },
  ];
}

export default AccountPayoutsManagePage;
